import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class AbstractMasterViewDrawerDetailsComponent {
  @Input() toggleDrawerDetails: (open: boolean) => void;
}
